import type { Timestamp } from 'firebase/firestore'
import type { FirestoreType } from './firestoreType'

export type TaskDataMap = {
  [TaskType.ExtraPayment]: ExtraPaymentTask
  [TaskType.PrescriptionAttachment]: PrescriptionAttachmentTask
}

export type TaskData<T extends TaskType = TaskType>
  = T extends keyof TaskDataMap ? TaskDataMap[T] : never

export type Task = FirestoreType & {
  UserId: string
  ReferenceId: string
  Type: TaskType
  Status: TaskStatus
  StatusUpdatedBy?: string
  IsCompleted: boolean
  TaskData: TaskData<TaskType>
}

export type ExtraPaymentTask = {
  Amount: string
  Note: string
  MessageRead: boolean
  ApprovedByUser: boolean | null
}

export type PrescriptionAttachmentTask = {
  AttachmentUrl: string
  Status: PrescriptionAttachmentTaskStatus
  MailContent?: MailContent
  Partner: AttachmentPartner
  DeskTicketId?: string
}

export enum AttachmentPartner {
  Tmc = 'TMC',
}

export type MailContent = {
  Subject: string
  Body: string
  From: string
  Date: Timestamp
}

export type ExtraPaymentTaskEvent = {
  Amount: string
  Note?: string
}

export enum PrescriptionAttachmentTaskStatus {
  AwaitingProcessing = 'AwaitingProcessing',
  AwaitingApproval = 'AwaitingApproval',
}

export enum TaskType {
  ExtraPayment = 'ExtraPayment',
  PrescriptionAttachment = 'PrescriptionAttachment',
}
export enum TaskStatus {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
}
